import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';
import { DeviceContextService, GlobalEventBusService, hd, IDeviceModel } from '@nx-fe/services';
import { GlobalEvents } from '../../../../../../../core/global-event-constants';
import { ActivityContextService } from 'xsmodules/ticket/components/ticket-details-panel/activity/activity-context';
import { SnapshotActivity } from '../../../../../ticket.model';
import { RcDeviceService } from '../../../../../../remote-control/services/rc-device-service';
import { ISnapshotInformation } from '../../../../snapshot/snapshot/snapshot.models';

@Component({
  selector: 'xs-snapshot-activity-content',
  templateUrl: './snapshot-activity-content.component.html',
  styleUrls: ['./snapshot-activity-content.component.scss'],
})
export class SnapshotActivityContentComponent implements OnInit {
  @Input() snapshot: SnapshotActivity;
  @Input() placeholder: string;
  @Input() error: string;
  @Input('disable') isSaving = false;
  @Input() activityCtrl: ActivityContextService;
  @Output() saveNote = new EventEmitter<SnapshotActivity>();
  @Output() updateEditing = new EventEmitter<boolean>();

  /** Indicates that we are calling that component in Self Service Portal */
  @Input()
  public isSPPMode: boolean;

  platformThumbnail: string;
  noteText = '';
  editing = false;
  toggleFocus = false;

  constructor(
    private xsI18nPipe: XsI18nPipe,
    private deviceContextService: DeviceContextService,
    private deviceService: RcDeviceService,
    private globalEventBusService: GlobalEventBusService
  ) {}

  ngOnInit(): void {
    this.noteText = this.snapshot?.description || '';

    if (!this.placeholder) {
      this.placeholder = this.xsI18nPipe.transform('note_Placeholder_Text');
    }

    this.platformThumbnail = this.deviceService.getPlatformCssClass(this.snapshot.details.family);
  }

  /** Indicate whether description has changed */
  get hasChanged(): boolean {
    return (this.noteText || '') !== (this.snapshot?.description || '');
  }

  save() {
    const temp = this.snapshot;
    temp.description = this.noteText;
    this.saveNote.emit(temp);
  }

  cancel() {
    this.noteText = this.snapshot.description;
    this.setError(undefined);
  }

  private setError(err: string) {
    this.error = err;
  }

  setEditing(value: boolean) {
    this.editing = value;
    this.updateEditing.emit(value);
  }

  getConnectionName = (): string => {
    const details = this.snapshot.details;
    if (details?.mcConnectionName) {
      return details.mcConnectionName;
    }

    return this.xsI18nPipe.transform(
      details?.isDefaultConnection
        ? 'associateDevices_Default_Instance_Caption'
        : 'associateDevices_Unknown_Instance_Caption'
    );
  };

  previewSavedSnapshot = () => {
    console.log('previewSavedSnapshot', this.deviceContextService.devices, this.snapshot);
    this.deviceContextService.getDeviceInfo(this.snapshot.details.mcDeviceId).subscribe((deviceModel: IDeviceModel) => {
      console.log(deviceModel);
      // If the device is unavailable, set the device information
      if (!deviceModel) {
        deviceModel = {
          deviceId: this.snapshot.details.deviceId, /// deviceCaptureActivity.deviceId,
          deviceName: this.snapshot.details.deviceName, // deviceCaptureActivity.deviceName,
          mcConnectionId: this.snapshot.details.mcConnectionId, // deviceCaptureActivity.mcConnectionId,
          $$mcConnectionName: this.snapshot.details.mcConnectionName, // deviceCaptureActivity.mcConnectionName,
          $$isDefaultMcConnection: this.snapshot.details.isDefaultConnection, // deviceCaptureActivity.isDefaultConnection,
          family: this.snapshot.details.family, // deviceCaptureActivity.deviceFamily,
        } as IDeviceModel;
      } else if (!deviceModel.deviceName || !deviceModel.family) {
        deviceModel.deviceName = this.snapshot.details.deviceName; // deviceCaptureActivity.deviceName;
        deviceModel.family = this.snapshot.details.family; // deviceCaptureActivity.deviceFamily;
      }

      // snapshotActivity: hd.ISnapshotActivity;
      // mcConnectionName: string;
      // device: IDeviceModel;
      // workPanelKey: string;

      this.globalEventBusService.broadcast(GlobalEvents.previewSnapshot, {
        snapshotActivity: (<unknown>this.snapshot) as hd.ISnapshotActivity,
        device: deviceModel,
        mcConnectionId: this.snapshot.details.mcConnectionId,
        mcConnectionName: this.snapshot.details.mcConnectionName, // deviceCaptureActivity.mcConnectionName,
        isDefaultConnection: this.snapshot.details.isDefaultConnection,
        workPanelKey: null, // ??
      } as ISnapshotInformation);
    });
  };
}
